export default __webpack_public_path__ + "static/media/edit-icon.2a5d921c.svg";